import { CertificationWorkspace } from 'src/app/shared/models/workspace/certificationWorkspace';

export class Certification {
  public id: string;
  public name: string;
  public workspaces: CertificationWorkspace[];
  public createdBy: string;
  public createdOn: Date;
  public updatedBy: string;
  public updatedOn: Date;

  constructor(certification: any = undefined) {
    if (certification) {
      this.setProperties(certification);
    }
  }

  private setProperties(certification: any) {
    this.id = certification.id;
    this.name = certification.name;
    this.workspaces = certification.workspaces ?? [];
    this.createdBy = certification.createdBy;
    this.createdOn = certification.createdOn;
    this.updatedBy = certification.updatedBy;
    this.updatedOn = certification.updatedOn;
  }
}
